var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publishing_standard"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.t('home.publishedTips')))])]),_c('a-button',{nativeOn:{"click":function($event){$event.stopPropagation();return _vm.submit.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.t('home.viewMore')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }